import React from 'react'
import LtsDropdownUnidade from '../../../components/lottus/lts-dropdown-unidade'
import _ from 'lodash'
import utils, { getMessage } from '../../../utils'
import { Card } from 'primereact/card'
import LtsDropdownIdValue from '../../../components/lottus/lts-dropdown-id-value'
import LtsLookupContaCorrente from '../../../components/lottus/lts-lookup-conta-corrente'
import LtsCalendar from '../../../components/lottus/lts-calendar'
import LtsCurrency from '../../../components/lottus/lts-currency'
import LtsLookupPessoa from '../../../components/lottus/lts-lookup-pessoa'
import LtsLookupTaxa from '../../../components/lottus/lts-lookup-taxa'
import { enums } from '../../../constants'

const filtroTaxaCaixa = {
  campo: 'grupoFinanceiro_caixa',
  valor: true,
  tipoFiltro: 'IGUAL_A',
}

export const TransferenciaEntreContasForm = (props) => {
  const record = props.record
  const messages = props.messages
  const setField = props.setField

  const resolveFiltersCaixa = (filters) => {
    filters.push(filtroTaxaCaixa)
  }

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <Card>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-3">
              <LtsDropdownUnidade
                name={'unidadeOrigem'}
                label={getMessage(messages, 'transferenciaentrecontas.label.unidadeorigem')}
                value={record.unidadeOrigem}
                onChange={(e) => props.onChangeUnidade('unidadeOrigem', e)}
                disabled={props.disableUnit}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-3">
              <LtsLookupTaxa
                value={_.get(record, 'taxaOrigem.value', null)}
                editHidden={true}
                field={'taxaOrigem'}
                multiple={false}
                onChange={(e) => {
                  const value = { id: _.get(e, 'oid', null), value: _.get(e, 'grupoFinanceiro_descricao', null) }
                  setField('taxaOrigem', value)
                }}
                resolveFilters={resolveFiltersCaixa}
                label={getMessage(messages, 'transferenciaentrecontas.label.taxaOrigem')}
                header={getMessage(messages, 'transferenciaentrecontas.label.taxaOrigem')}
                filtroTipoTaxa={enums.TipoTaxa.SAIDA}
                idUnidade={_.get(record, 'unidadeOrigem.id', null)}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-3">
              <LtsDropdownIdValue
                name={'formaPagamentoOrigem'}
                value={record.formaPagamentoOrigem}
                onChange={(e) => setField('formaPagamentoOrigem', e)}
                label={getMessage(messages, 'transferenciaentrecontas.label.formapagamentoorigem')}
                options={props.formasPagamentoOrigem}
                disabled={!record.unidadeOrigem}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-3">
              <LtsLookupContaCorrente
                label={utils.getMessage(messages, 'transferenciaentrecontas.label.contacorrenteorigem')}
                value={_.get(record, 'contaCorrenteOrigem.value', '')}
                oidRecord={_.get(record, 'contaCorrenteOrigem.id', '')}
                history={props.history}
                onChange={(e) => setField('contaCorrenteOrigem', { id: e.oid, value: e.descricao })}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-3">
              <LtsLookupPessoa
                header={getMessage(messages, 'transferenciaentrecontas.label.pagador')}
                name={'pagador'}
                field={'nome'}
                label={'Pesquisar por pagador'}
                value={_.get(record, 'pagador', null)}
                oidRecord={_.get(record, 'pagador.id', '')}
                history={props.history}
                onChange={(e) => setField('pagador', { id: e.oid, value: e.nome })}
                showAddButton={false}
                editHidden={false}
              />
            </div>
          </div>

          {/*  DESTINO  */}

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-3">
              <LtsDropdownUnidade
                name={'unidadeDestino'}
                label={getMessage(messages, 'transferenciaentrecontas.label.unidadedestino')}
                value={record.unidadeDestino}
                onChange={(e) => props.onChangeUnidade('unidadeDestino', e)}
                disabled={props.disableUnit}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-3">
              <LtsLookupTaxa
                value={_.get(record, 'taxaDestino.value', null)}
                editHidden={true}
                field={'taxaDestino'}
                multiple={false}
                onChange={(e) => {
                  const value = { id: _.get(e, 'oid', null), value: _.get(e, 'grupoFinanceiro_descricao', null) }
                  setField('taxaDestino', value)
                }}
                resolveFilters={resolveFiltersCaixa}
                label={getMessage(messages, 'transferenciaentrecontas.label.taxaDestino')}
                header={getMessage(messages, 'transferenciaentrecontas.label.taxaDestino')}
                filtroTipoTaxa={enums.TipoTaxa.ENTRADA}
                idUnidade={_.get(record, 'unidadeOrigem.id', null)}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-3">
              <LtsDropdownIdValue
                name={'formaPagamentoDestino'}
                value={record.formaPagamentoDestino}
                onChange={(e) => setField('formaPagamentoDestino', e)}
                label={getMessage(messages, 'transferenciaentrecontas.label.formapagamentodestino')}
                options={props.formasPagamentoDestino}
                disabled={!record.unidadeDestino}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-3">
              <LtsLookupContaCorrente
                label={utils.getMessage(messages, 'transferenciaentrecontas.label.contacorrentedestino')}
                value={_.get(record, 'contaCorrenteDestino.value', '')}
                oidRecord={_.get(record, 'contaCorrenteDestino.id', '')}
                history={props.history}
                onChange={(e) => setField('contaCorrenteDestino', { id: e.oid, value: e.descricao })}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-3">
              <LtsLookupPessoa
                header={getMessage(messages, 'transferenciaentrecontas.label.recebedor')}
                name={'recebedor'}
                field={'nome'}
                label={'Pesquisar por recebedor'}
                value={_.get(record, 'recebedor', null)}
                oidRecord={_.get(record, 'recebedor.id', '')}
                history={props.history}
                onChange={(e) => setField('recebedor', { id: e.oid, value: e.nome })}
                showAddButton={false}
                editHidden={false}
              />
            </div>
          </div>

          {/* ---- */}
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-3">
              <LtsCalendar
                label={utils.getMessage(messages, 'transferenciaentrecontas.label.datapagamento')}
                value={record.dataPagamento}
                onChange={(e) => props.setField('dataPagamento', e)}
                name="dataPagamento"
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-3">
              <LtsCurrency
                value={record.valor}
                name={'valor'}
                label={utils.getMessage(messages, 'transferenciaentrecontas.label.valor')}
                onChange={(e) => props.setField('valor', e)}
              />
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}
